export default "__VITE_PUBLIC_ASSET__157c0023__"